"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addRoleSectionToRole = addRoleSectionToRole;
exports.deleteRoleSectionFromRole = deleteRoleSectionFromRole;
exports.addSectionToRole = addSectionToRole;
exports.editSectionFromRole = editSectionFromRole;
exports.updateRoleOverrideDates = updateRoleOverrideDates;
exports.updateRoleEmployees = updateRoleEmployees;
exports.updateRoleDayRequiredNum = updateRoleDayRequiredNum;
exports.updateRoleEmployeePos = updateRoleEmployeePos;
exports.updateRoleEmployeeCount = updateRoleEmployeeCount;
exports.updateRoleEmployeePriority = updateRoleEmployeePriority;
exports.updateRoleEvenlyAllocation = updateRoleEvenlyAllocation;
exports.updateRoleWorkEvenlyAllocation = updateRoleWorkEvenlyAllocation;
exports.updateRoleType = updateRoleType;
async function addRoleSectionToRole(userId, activeBranchId, payload) {
    const requestURL = `/dashboard/${userId}/role_slot_section?c=${activeBranchId}`;
    const formData = new FormData();
    formData.set("roleID", payload.roleId.toString());
    formData.set("sectionRoleID", payload.sectionRoleId.toString());
    try {
        const response = await fetch(requestURL, {
            method: 'POST',
            body: formData,
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
async function deleteRoleSectionFromRole(userId, activeBranchId, payload) {
    const url = `/dashboard/${userId}/role_slot_section?c=${activeBranchId}`;
    const searchParams = new URLSearchParams({
        "roleID": payload.roleId.toString(),
        "sectionRoleID": payload.sectionRoleId.toString()
    });
    const requestURL = `${url}&${searchParams.toString()}`;
    try {
        const response = await fetch(requestURL, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
function createFormDataForSectionReq(payload, isEdit) {
    const formData = new FormData();
    formData.set("roleID", payload.roleId.toString());
    formData.set("from", payload.from);
    formData.set("to", payload.to);
    formData.set("purpose", payload.purpose);
    formData.set("rest", payload.isRest.toString());
    formData.set("color", payload.color);
    formData.set("memo", payload.memo);
    if (isEdit && payload.sectionId) {
        formData.set("sectionID", payload.sectionId.toString());
    }
    if (payload.roleSectionId) {
        formData.set("sectionRoleID", payload.roleSectionId.toString());
    }
    return formData;
}
async function addSectionToRole(userId, activeBranchId, payload) {
    const requestURL = `/dashboard/${userId}/role_slot_section?c=${activeBranchId}`;
    const formData = createFormDataForSectionReq(payload, false);
    try {
        const response = await fetch(requestURL, {
            method: 'POST',
            body: formData,
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
async function editSectionFromRole(userId, activeBranchId, payload) {
    const requestURL = `/dashboard/${userId}/role_slot_section?c=${activeBranchId}`;
    const formData = createFormDataForSectionReq(payload, true);
    try {
        const response = await fetch(requestURL, {
            method: 'PUT',
            body: formData,
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
async function updateRoleOverrideDates(userId, roleId, activeBranchId, payload) {
    const url = `/dashboard/${userId}/role/${roleId}?c=${activeBranchId}`;
    const formData = new URLSearchParams();
    if (payload.deleteDate) {
        formData.set("deleteDate", payload.deleteDate);
    }
    if (payload.addDate) {
        formData.set("addDate", payload.addDate);
        formData.set("num", payload.num?.toString() || "0");
    }
    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: formData,
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
async function updateRoleEmployees(branchId, userId, payload) {
    const data = new URLSearchParams({
        employees: String(payload.employeeIds),
        employeesLength: String(payload.employeeIds.length),
    });
    try {
        const response = await fetch(`/dashboard/${userId}/role/${payload.roleId}?c=${branchId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: data.toString(),
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
async function updateRoleDayRequiredNum(branchId, userId, roleId, roleDayReqNumbers) {
    const data = new URLSearchParams({
        dayNumbers: roleDayReqNumbers.toString(),
    });
    try {
        const response = await fetch(`/dashboard/${userId}/role/${roleId}?c=${branchId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: data.toString(),
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
async function updateRoleEmployeePos(branchId, userId, roleId, roleJoinedEmployees) {
    const data = new URLSearchParams({
        employees: roleJoinedEmployees.toString(),
        employeesLength: roleJoinedEmployees.length.toString(),
    });
    try {
        const response = await fetch(`/dashboard/${userId}/role/${roleId}?c=${branchId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: data.toString(),
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
async function updateRoleEmployeeCount(branchId, userId, roleId, payload) {
    const params = new URLSearchParams();
    for (const [key, val] of Object.entries(payload)) {
        params.append(`EmployeeCount[${key}]`, val.toString());
    }
    try {
        const response = await fetch(`/dashboard/${userId}/role/${roleId}?c=${branchId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: params,
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
async function updateRoleEmployeePriority(branchId, userId, roleId, priorityType) {
    const data = new URLSearchParams({
        employeePriority: priorityType.toString(),
    });
    try {
        const response = await fetch(`/dashboard/${userId}/role/${roleId}?c=${branchId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: data.toString(),
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
async function updateRoleEvenlyAllocation(branchId, userId, roleId, value) {
    const data = new URLSearchParams({
        evenly: value.toString(),
        editSharedSettings: "true"
    });
    try {
        const response = await fetch(`/dashboard/${userId}/role/${roleId}?c=${branchId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: data.toString(),
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
async function updateRoleWorkEvenlyAllocation(branchId, userId, roleId, value) {
    const data = new URLSearchParams({
        workEvenly: value.toString(),
        editSharedSettings: "true"
    });
    try {
        const response = await fetch(`/dashboard/${userId}/role/${roleId}?c=${branchId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: data.toString(),
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
async function updateRoleType(branchId, userId, roleId, value) {
    const data = new URLSearchParams({
        type: value.toString(),
        editSharedSettings: "false"
    });
    try {
        const response = await fetch(`/dashboard/${userId}/role/${roleId}?c=${branchId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: data.toString(),
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
